<p-dialog
  header="Select scene..."
  styleClass="[&>.p-dialog-content]:!rounded-b-xl [&>.p-dialog-header]:!rounded-t-xl [&>.p-dialog-content]:!bg-purple-500/50 [&>.p-dialog-content]:!backdrop-blur-md [&>.p-dialog-header]:!bg-purple-700/50  [&>.p-dialog-header]:!h-12 [&>.p-dialog-header]:!backdrop-blur-md  !text-bo-white [&>.p-dialog-header]:!fill-white"
  [visible]="showSceneLauncher()"
  (visibleChange)="toggleSceneLauncher()"
  [style]="{ width: '50vw', fill: 'white' }"
  [modal]="true"
  [dismissableMask]="true"
  [resizable]="false"
  closable="false"
  data-e2e="scene-launcher"
>
  <ng-template pTemplate="header">
    <div class="flex w-full">
      <div class="bo-subheader flex-1 select-none !text-bo-white">
        Select scene...
      </div>
      <button>
        <svg-icon
          class="fill-white"
          src="fa-icons/xmark.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="toggleSceneLauncher()"
        />
      </button>
    </div>
  </ng-template>
  <div class="mt-4 flex select-none flex-col gap-3 px-6">
    <div class="flex gap-3">
      <button class="bo-button flex-1" (click)="selectScene(ScenePath.Objecto)">
        Objecto
      </button>
      <button
        class="bo-button-secondary flex-1"
        (click)="selectDemo(ScenePath.Objecto)"
      >
        Demo
      </button>
    </div>
    <div class="flex gap-3">
      <button class="bo-button flex-1" (click)="selectScene(ScenePath.Anatomo)">
        Anatomo
      </button>
      <button
        class="bo-button-secondary flex-1"
        (click)="selectDemo(ScenePath.Anatomo)"
      >
        Demo
      </button>
    </div>
  </div>
</p-dialog>
